import axios from 'axios';

export type ProductFeedbackRequest = {
  rating: number;
  message?: string;
  sourcePage: string;
};

export async function submitProductFeedback(payload: ProductFeedbackRequest) {
  const body: Record<string, unknown> = {
    rating: payload.rating,
    sourcePage: payload.sourcePage,
  };
  const message = payload.message?.trim();
  if (message) body.message = message;
  const response = await axios.post('/api/feedback', body);
  return response.data;
}
